module.exports = __webpack_public_path__ + "img/Picture1.3006c61f.png";